/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wild_Slim_Jay_DozeInputs */

const en_wild_slim_jay_doze = /** @type {(inputs: Wild_Slim_Jay_DozeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segment override`)
};

const de_wild_slim_jay_doze = /** @type {(inputs: Wild_Slim_Jay_DozeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segment-Überschreibung`)
};

/**
* | output |
* | --- |
* | "Segment override" |
*
* @param {Wild_Slim_Jay_DozeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wild_slim_jay_doze = /** @type {((inputs?: Wild_Slim_Jay_DozeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wild_Slim_Jay_DozeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wild_slim_jay_doze(inputs)
	return de_wild_slim_jay_doze(inputs)
});